import * as styles from './AlphabetList.module.css';

const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZÆØÅ'.split('');

export const AlphabetList = ({ list }: { list?: string[] }) => {
    if (!list) return null;
    return (
        <div className={styles.alphabet}>
            <div>
                {alphabet.map((letter) =>
                    list?.some((n) => n?.toUpperCase()?.startsWith(letter)) ? (
                        <a key={letter} href={`#${letter.toLowerCase()}`}>
                            {letter}
                        </a>
                    ) : (
                        <span key={letter}>{letter}</span>
                    ),
                )}
            </div>
        </div>
    );
};
